<div class="container-fluid">
<section>
	<div class="row mt-3">
		<div class="col-sm-4">
			<form>
				<div class="mb-3 row">
					<label class="col-sm-2 col-form-label" for="cropDropdown" jhiTranslate="program.crop"></label>
					<div class="col-sm-7">
						<ng-select name="cropDropdown" id="cropDropdown" width="100%"
									[items]="crops"
									[(ngModel)]="cropName"
									[placeholder]="'All'"
									data-test="dashboardCropDropdown"
									[clearable]="false"
									(change)="onCropChange()">
						</ng-select>
					</div>
					<div class="col-sm-auto">
						<div class="throbber" *ngIf="isLoading"></div>
					</div>
				</div>
				<div class="mb-3 row">
					<label class="col-sm-2 col-form-label" for="programDropdown" jhiTranslate="program.program"></label>
					<div class="col-sm-7">
						<!-- ngIf -> workaround to fire ajax load -->
						<ng-select name="programDropdown" id="programDropdown" width="100%" data-test="dashboardProgramDropdown"
									*ngIf="crops?.length"
                                    bindLabel="label"
                                    bindValue="id"
                                    [virtualScroll]="true"
									[(ngModel)]="programModel"
									[items]="programItems"
                                    (open)="search(select.searchTerm)"
                                    (scrollToEnd)="fetchMore(select.searchTerm)"
                                    (search)="onSearch(select.searchTerm)"
                                    (clear)="search(select.searchTerm)"
									(ngModelChange)="onProgramChange($event)"
                                   #select>
						</ng-select>
					</div>
					<div class="col-sm-auto">
						<button class="btn btn-info" jhiTranslate="program.launch" data-test="launchProgramButton"
								[disabled]="!programModel" (click)="onOpenProgram()"></button>
					</div>
				</div>
			</form>
		</div>
		<div class="col"><!-- filler --></div>
	</div>
	<div class="row mt-3" *ngIf="programModel" >
		<div class="col" *jhiHasAnyAuthority="PERMISSIONS">
			<nav>
				<ul class="nav nav-tabs">
					<li class="nav-item pe-1" *jhiHasAnyAuthority="MANAGE_STUDIES_VIEW_PERMISSIONS">
						<a class="nav-link" jhiTranslate="program.my.studies.tab.name" [routerLink]="['my-studies']"
						   [routerLinkActive]="['active']"
						   [queryParams]="{ programUUID: programModel }"></a>
					</li>
					<li class="nav-item pe-1" *jhiHasAnyAuthority="SEARCH_GERMPLASM_LISTS_PERMISSION">
						<a class="nav-link" jhiTranslate="program.my.lists.tab.name" [routerLink]="['my-lists']"
						   [routerLinkActive]="['active']"
						   [queryParams]="{ programUUID: programModel }"></a>
					</li>
				</ul>
			</nav>
			<div class="tab-content p-3">
				<router-outlet></router-outlet>
			</div>
		</div>
	</div>
</section>
</div>
